'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseFooter = function EnterpriseFooter(_ref) {
  var children = _ref.children,
      className = _ref.className;

  var styles = require('./EnterpriseFooter.scss');

  return _react2.default.createElement(
    'footer',
    { className: (0, _classnames2.default)(className, styles.root) },
    children || _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        '\xA9 ',
        new Date().getFullYear(),
        ' Travelport. All rights reserved. Any trademarks herein are the property of their respective owners'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Travelport and the Travelport logo are trademarks of Travelport.'
      )
    )
  );
};

EnterpriseFooter.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};

exports.default = EnterpriseFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseFooter/EnterpriseFooter.jsx
// module id = 1586
// module chunks = 0